import React from 'react';
import { PaymentMethod } from '../../../../types';
import { CreditCardIcon, PixIcon, BoletoIcon } from '../../../icons';

interface PaymentViewProps {
  paymentInformation: any;
}

const PaymentView: React.FC<PaymentViewProps> = ({ paymentInformation }) => {
  if (!paymentInformation.paymentMethod) {
    return <p>Nenhum método de pagamento selecionado.</p>;
  }

  const getPaymentIcon = (method: PaymentMethod) => {
    switch (method) {
      case PaymentMethod.CREDIT_CARD: return <CreditCardIcon className="w-5 h-5 mr-2 text-primary" />;
      case PaymentMethod.PIX: return <PixIcon className="w-5 h-5 mr-2 text-primary" />;
      case PaymentMethod.BOLETO: return <BoletoIcon className="w-5 h-5 mr-2 text-primary" />;
      default: return null;
    }
  };

  const getPaymentName = (method: PaymentMethod) => {
    switch (method) {
      case PaymentMethod.CREDIT_CARD: return 'Cartão de Crédito';
      case PaymentMethod.PIX: return 'PIX';
      case PaymentMethod.BOLETO: return 'Boleto';
      default: return method;
    }
  };

  const renderPaymentContent = () => {
    switch (paymentInformation.paymentMethod) {
      case PaymentMethod.CREDIT_CARD:
        const card = paymentInformation.creditCard;
        if (!card) return <p>Dados do cartão não disponíveis.</p>;
        return (
          <>
            <p><strong>Número:</strong> {card.cardNumber}</p>
            <p><strong>Validade:</strong> {card.expirationDate}</p>
            <p><strong>Nome:</strong> {card.cardholderName}</p>
            <p><strong>CPF:</strong> {card.cpf}</p>
            <p><strong>Parcelas:</strong> {card.installments}x</p>
          </>
        );
      case PaymentMethod.PIX:
        const pix = paymentInformation.pix;
        if (!pix?.cpf) return <p>CPF para PIX não informado.</p>;
        return <p><strong>CPF:</strong> {pix.cpf}</p>;
      case PaymentMethod.BOLETO:
        const boleto = paymentInformation.boleto;
        if (!boleto?.cpf) return <p>CPF para boleto não informado.</p>;
        return <p><strong>CPF:</strong> {boleto.cpf}</p>;
      default:
        return <p>Método de pagamento não reconhecido.</p>;
    }
  };

  return (
    <div className="text-text-secondary dark:text-gray-300">
      <div className="flex items-center mb-4">
        {getPaymentIcon(paymentInformation.paymentMethod)}
        <span className="font-semibold text-text-primary dark:text-gray-100">
          {getPaymentName(paymentInformation.paymentMethod)}
        </span>
      </div>
      <div className="space-y-2">
        {renderPaymentContent()}
      </div>
    </div>
  );
};

export default PaymentView; 